(function($, isMobile) {

  function hasMouse() {
    return !!('onmousemove' in window);
  }

  // Subscribe email
  $('.subscribe button').on('click', function(e) {
    var subscribe = new Request(servicesUrl + '/account/massmail/subscribe-blogs', {
      sessionId: sessionModule.getSessionId(),
      locationId: getLocation(),
      email: $('.subscribe .subscribe-email').val()
    })
    subscribe.afterErrorDialogFunction(function() {
      $('.subscribe .subscribe-email').focus();
    });
    subscribe.afterSuccessDialogFunction(function() {
      $('.subscribe .subscribe-email').val('');
    });
    subscribe.call();
  });

  $('.subscribe input').on('keyup', function() {
    $('.subscribe input').val($(this).val());
  });

  $('body').on('keyup', function(e) {
    if ($('.popup').is(':visible')) {
      var code = (e.keyCode ? e.keyCode : e.which);
      if (code == 13) { //Enter keycode
        $('.backdrop').addClass('hide');
        $('.popup').addClass('hide');
      }
    }
  });

  // Share Article
  // Check if marketplace will have a select box by checking .marketplace data('item-count')
  if (parseInt($('.marketplace').data('item-count')) > 1) {
    // Show first .body occurence of each marketbox
    $('.marketplace .body').addClass('hide'); // default
    // First marketplace first body
    $('.marketplace').eq(0).find('.body').eq(0).removeClass('hide'); // target
    // Second marketplace first body
    $('.marketplace').eq(1).find('.body').eq(0).removeClass('hide'); // target
  }

  // Marketplace selection
  $('.marketplace .selection select').on('change', function() {
    var _this = $(this);
    if ($('.marketplace .selection select').length > 1) {
      $('.marketplace .selection select').each(function(i, select) {
        $(select).val(_this.val());
      });
    }
    $('.marketplace .body').addClass('hide'); // reset
    // First marketplace target body
    $('.marketplace').eq(0).find('.body').eq(_this.val()).removeClass('hide'); // target
    // Second marketplace target body
    $('.marketplace').eq(1).find('.body').eq(_this.val()).removeClass('hide'); // target
  });

  // Marketplace expand/collapse
  $('.marketplace .with-expand').on('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    var _this = $(this),
      $target = _this.next('.body');

    // Sync two marketplace
    $('.marketplace').eq(0).children().eq(_this.index()).next('.body').toggleClass('hide');
    $('.marketplace').eq(1).children().eq(_this.index()).next('.body').toggleClass('hide');

    if ($target.is(':visible')) {
      $('.marketplace').eq(0).children().eq(_this.index()).find('.image').addClass('active');
      $('.marketplace').eq(0).children().eq(_this.index()).removeClass('no-border-bot');
      $('.marketplace').eq(1).children().eq(_this.index()).find('.image').addClass('active');
      $('.marketplace').eq(1).children().eq(_this.index()).removeClass('no-border-bot');
    } else {
      $('.marketplace').eq(0).children().eq(_this.index()).find('.image').removeClass('active');
      $('.marketplace').eq(0).children().eq(_this.index()).addClass('no-border-bot');
      $('.marketplace').eq(1).children().eq(_this.index()).find('.image').removeClass('active');
      $('.marketplace').eq(1).children().eq(_this.index()).addClass('no-border-bot');
    }
  });

  // Hack to not hide popover when you hover on the popover itself
  var originalLeave = $.fn.popover.Constructor.prototype.leave;
  $.fn.popover.Constructor.prototype.leave = function(obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
    var container, timeout;

    originalLeave.call(this, obj);

    if (obj.currentTarget) {
      // container = $(obj.currentTarget).siblings('.popover') // original
      // Since we add container body to popover option, we need now to
      // get the .popover on the body instead of siblings('.popover')
      container = $('body').find('.popover');
      timeout = self.timeout;
      container.one('mouseenter', function() {
        // We entered the actual popover � call off the dogs
        clearTimeout(timeout);
        // Let's monitor popover content instead
        container.one('mouseleave', function() {
          $.fn.popover.Constructor.prototype.leave.call(self, self);
        });
      })
    }
  };

  $('sup a').each(function(i, a) {
    var content = $(a).data('content');
    var str = content.replace('<a', '<a target="_blank"');
    $(a).attr('data-content', str);
  })

  // Article's popover init
  $('article').popover({
    selector: '[data-toggle="popover"]',
    trigger: 'hover',
    placement: 'auto',
    delay: {
      show: 50,
      hide: 400
    },
    container: 'body' // Added to add a max-width for popovers
  });

  // Check for mobile and tablet
  if (isMobile || !hasMouse) {
    // Prevent going down to reference in mobile and touch devices
    $('[data-toggle="popover"]').on('click', function(e) {
      e.preventDefault();
    });

    // Set currently selected link
    document.addEventListener('touchstart', swipeModule.touchStart, {
      passive: true
    });
    /*document.addEventListener('touchmove', function() {
     $('.swipe-left').removeClass('hide');
     $('.swipe-right').removeClass('hide');
     }, false);*/
    document.addEventListener('touchend', function(e) {
      swipeModule.touchEnd(e, function() {
        if ($('.main-menu').is(':visible') || !nextPage.length) return; // disbale swipe navigation when main-menu is open
        if (nextPage != null) {
          // Open loading popup
          new Loading().render();
          // Redirect page next
          document.location.href = nextPage;
        }
      }, function() {
        if ($('.main-menu').is(':visible') || !prevPage.length) return; // disbale swipe navigation when main-menu is open
        if (prevPage != null) {
          // Open loading popup
          new Loading().render();
          // Redirect page prev
          document.location.href = prevPage;
        }
      });

      /*$('.swipe-left').addClass('hide');
        $('.swipe-right').addClass('hide');*/
    }, {
      passive: true
    });

    // setTimeout(function() {
    if (readCookie('newSessionVisit') === 'yes') {
      popupModule.open($('.popup-new-visitor'), 'popupNewVisitor');
    }
    // }, 1000);

    $('.popup-new-visitor').on('click', function(e) {
      popupModule.close($('.popup-new-visitor'), 'popupNewVisitor');
    });
  }

  // Resolve height problem in .side-nav caused by position absolute
  // 1339 is the total height of .side-nav
  if ($('article').innerHeight() < 1339) {
    $('.side-nav').css('position', 'static');
  }

  $('.category > li > a').on('click', function() {
    var _this = $(this);
    var imgSrc = _this.find('img').attr('src');
    _this.next().toggleClass('hide');
    if (_this.next().hasClass('hide')) {
      imgSrc = imgSrc.replace('down', 'right');
    } else {
      imgSrc = imgSrc.replace('right', 'down');
    }
    _this.find('img').attr('src', imgSrc);
  });

  $('.category > li > ul > li > a').on('click', function() {
    var _this = $(this);
  });

  var activeLink = window.location.pathname;

  if (activeLink == '') {
    $('.category > li > ul').addClass('hide');
    $('.category > li > a').eq(0).trigger('click');
  } else {
    $('.category > li').each(function(i, el) {
      var _this = $(el),
        childIds = _this.data('child').slice(0, -1).split(',');
      if ($.inArray(activeLink, childIds) != -1) {
        $('.category > li > ul').addClass('hide');
        _this.find('> a').trigger('click');
      }
    });
  }

  // $('.share-comment-wrap .share-article').on('click', function(e) {
  //   e.preventDefault();
  //   var url = '';
  //   var w = 600;
  //   var h = 300;
  //   if($(this).hasClass('fb')) {
  //     url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($(this).attr('href'));
  //   } else if($(this).hasClass('tw')) {
  //     url = 'https://twitter.com/home?status=' + encodeURIComponent($(this).attr('href')) + '%0A' + encodeURIComponent($(this).attr('href'));
  //     h = 254;
  //   } else if($(this).hasClass('li')) {
  //     url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent($(this).attr('href')) + '&title=' + encodeURIComponent($(this).data('title')) + '&summary=' + encodeURIComponent($(this).data('summary')) + '&source=BullionStar';
  //     h = 473;
  //   } else if($(this).hasClass('go')) {
  //     url = 'https://plus.google.com/share?url=' + encodeURIComponent($(this).attr('href'));
  //     h = 490;
  //   } else if($(this).hasClass('re')) {
  //     url = 'https://www.reddit.com/submit?url=' + encodeURIComponent($(this).attr('href')) + '&title=' +  encodeURIComponent($(this).data('title'));
  //   } else if($(this).hasClass('pi')) {
  //     url = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent($(this).attr('href')) + '&media=' + '&description=' +  encodeURIComponent($(this).data('title'));
  //   } 
  //   window.open(url, 'targetWindow', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=' + w + ',height=' + h);
  // });

})(jQuery, window.isMobile || false);